var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-card",
    {
      staticClass: "d-flex flex-column h-100",
      attrs: { elevation: "0", outlined: "", "min-height": "350" },
    },
    [
      _c(
        "v-card-title",
        {
          staticClass:
            "py-1 white--text d-flex align-center justify-space-between",
          class: _vm.$vuetify.theme.dark ? "black" : "primary",
          staticStyle: { "flex-wrap": "nowrap" },
        },
        [
          _c(
            "div",
            {
              staticClass: "d-flex align-center",
              staticStyle: { flex: "1 1 auto", "min-width": "0" },
            },
            [
              _c(
                "v-icon",
                { staticClass: "mr-2", attrs: { color: "white", medium: "" } },
                [_vm._v("ballot")]
              ),
              _vm._v(" "),
              _c(
                "span",
                {
                  staticClass:
                    "white--text body-font body-1 font-weight-bold text-uppercase text-ellipsis",
                },
                [_vm._v(_vm._s(_vm.$t("app.uploadedGames")))]
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-btn",
            {
              staticClass: "pl-0 pr-0",
              staticStyle: { "flex-shrink": "0" },
              attrs: { text: "", small: "", to: `/uploaded-games` },
            },
            [
              _c(
                "span",
                {
                  staticClass:
                    "white--text text-decoration-underline font-weight-bold",
                },
                [_vm._v(_vm._s(_vm.$t("uploadedGames.goToUploadedGames")))]
              ),
              _vm._v(" "),
              _c(
                "v-icon",
                { staticClass: "ml-1", attrs: { small: "", color: "white" } },
                [_vm._v("keyboard_arrow_right")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-card-text",
        {
          staticClass: "d-flex flex-column pb-1 overflow-auto flex-grow-1 pt-2",
        },
        [
          !_vm.loading
            ? [
                _c("v-data-table", {
                  attrs: {
                    dense: "",
                    "disable-items-per-page": "",
                    headers: _vm.headers,
                    items: _vm.games,
                    "footer-props": {
                      itemsPerPageOptions: _vm.$vuetify.breakpoint.smAndDown
                        ? [1]
                        : [5],
                    },
                    loading: _vm.loading,
                  },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "item.link",
                        fn: function ({ item }) {
                          return [
                            _c(
                              "v-btn",
                              {
                                staticClass: "mr-2 px-1 elevation-0",
                                attrs: {
                                  color: "secondary",
                                  target: "_blank",
                                  to: `/video-highlights/game/${item.gameId}`,
                                  "x-small": "",
                                },
                              },
                              [
                                _c("v-icon", { attrs: { small: "" } }, [
                                  _vm._v("ondemand_video"),
                                ]),
                              ],
                              1
                            ),
                          ]
                        },
                      },
                      {
                        key: "item.name",
                        fn: function ({ item }) {
                          return [
                            _c(
                              "router-link",
                              {
                                staticClass: "d-flex flex-column",
                                attrs: {
                                  to: `/game/${item.gameId}`,
                                  target: "_blank",
                                },
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "d-flex justify-space-between mt-1",
                                  },
                                  [
                                    _c(
                                      "span",
                                      {
                                        staticClass:
                                          "body-1 text-ellipsis w-85",
                                      },
                                      [_vm._v(_vm._s(item.homeTeamName))]
                                    ),
                                    _vm._v(" "),
                                    _c("span", { staticClass: "body-1" }, [
                                      _vm._v(_vm._s(item.homeTeamResult)),
                                    ]),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "d-flex justify-space-between mb-1",
                                  },
                                  [
                                    _c(
                                      "span",
                                      {
                                        staticClass:
                                          "body-1 text-ellipsis w-85",
                                      },
                                      [_vm._v(_vm._s(item.awayTeamName))]
                                    ),
                                    _vm._v(" "),
                                    _c("span", { staticClass: "body-1" }, [
                                      _vm._v(_vm._s(item.awayTeamResult)),
                                    ]),
                                  ]
                                ),
                              ]
                            ),
                          ]
                        },
                      },
                      {
                        key: "item.leagueName",
                        fn: function ({ item }) {
                          return [
                            _c("span", { staticClass: "body-1" }, [
                              _vm._v(_vm._s(item.leagueName)),
                            ]),
                          ]
                        },
                      },
                      {
                        key: "header.collectionCompleted",
                        fn: function ({ item }) {
                          return [
                            _c(
                              "v-tooltip",
                              {
                                attrs: {
                                  top: "",
                                  color: "lightSecondary lighten-4",
                                  "max-width": "300",
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "activator",
                                      fn: function ({ on }) {
                                        return [
                                          _c("span", _vm._g({}, on), [
                                            _vm._v("CC"),
                                          ]),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  true
                                ),
                              },
                              [
                                _vm._v(" "),
                                _c(
                                  "span",
                                  { staticClass: "black--text body-1" },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t(
                                          `uploadedGames.collectionCompleted`
                                        )
                                      )
                                    ),
                                  ]
                                ),
                              ]
                            ),
                          ]
                        },
                      },
                      {
                        key: "item.collectionCompleted",
                        fn: function ({ item }) {
                          return [
                            item.collectionCompleted
                              ? _c(
                                  "v-icon",
                                  { attrs: { color: "green", small: "" } },
                                  [_vm._v("check_circle")]
                                )
                              : _c(
                                  "v-icon",
                                  { attrs: { color: "blue", small: "" } },
                                  [_vm._v("schedule")]
                                ),
                          ]
                        },
                      },
                      {
                        key: "header.sla",
                        fn: function ({ item }) {
                          return [
                            _c(
                              "v-tooltip",
                              {
                                attrs: {
                                  top: "",
                                  color: "lightSecondary lighten-4",
                                  "max-width": "300",
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "activator",
                                      fn: function ({ on }) {
                                        return [
                                          _c("span", _vm._g({}, on), [
                                            _vm._v("SLA"),
                                          ]),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  true
                                ),
                              },
                              [
                                _vm._v(" "),
                                _c(
                                  "span",
                                  { staticClass: "black--text body-1" },
                                  [_vm._v(_vm._s(_vm.$t(`uploadedGames.sla`)))]
                                ),
                              ]
                            ),
                          ]
                        },
                      },
                      {
                        key: "item.sla",
                        fn: function ({ item }) {
                          return [
                            _c("span", { staticClass: "monospace-font" }, [
                              _vm._v(_vm._s(item.sla)),
                            ]),
                          ]
                        },
                      },
                      {
                        key: "item.tsTime",
                        fn: function ({ item }) {
                          return [
                            _c("span", { staticClass: "body-1" }, [
                              _vm._v(_vm._s(item.ts)),
                            ]),
                          ]
                        },
                      },
                    ],
                    null,
                    false,
                    3771527608
                  ),
                }),
              ]
            : [
                _c(
                  "div",
                  {
                    staticClass:
                      "mt-4 pl-6 pr-4 d-flex align-center justify-space-between",
                  },
                  [
                    _c("v-skeleton-loader", {
                      staticClass: "ma-0",
                      attrs: { type: "text", width: "30%" },
                    }),
                    _vm._v(" "),
                    _c("v-skeleton-loader", {
                      staticClass: "ma-0",
                      attrs: { type: "text", width: "15%" },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass:
                      "px-6 py-4 flex-grow-1 d-flex flex-column justify-space-around",
                  },
                  _vm._l(4, function (i) {
                    return _c("v-skeleton-loader", {
                      key: i,
                      staticClass: "my-2",
                      attrs: { type: "text", width: "100%" },
                    })
                  }),
                  1
                ),
              ],
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }